import React, { memo } from 'react';
import searchCheckIcon from '../../../assets/images/search-check.svg';

const BundlesCountBanner = ({ bundlesCount, filtersApplied }) => (
	<div className="shift-count-info">
		<img src={searchCheckIcon} alt="info" />
		<div>
			Showing {bundlesCount > 1 ? `all ${bundlesCount} bundles` : '1 bundle'} with shifts within the selected date range
			{filtersApplied && ' and applied filters'}
		</div>
	</div>
);

export default memo(BundlesCountBanner);
